import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ApiBaseService} from "@portal/api/api-base-service";
import {ForgotPasswordRequest} from "@portal/api/requests/auth/forgot-password-request";
import {Observable, of, switchMap} from "rxjs";
import {ApiResponse} from "@portal/api/responses/api-response";
import {AuthToken} from "@portal/api/responses/Auth/auth-token";
import {ResetPasswordRequest} from "@portal/api/requests/auth/reset-password-request";
import {LoginResponse} from "@portal/api/responses/Auth/login-response";
import {LoginRequest} from "@portal/api/requests/auth/login-request";
import {EmailConfirmationRequest} from "@portal/api/requests/auth/email-confirmation-request";
import {RegisterNewAccountRequest} from "@portal/api/requests/auth/register-new-account-request";


@Injectable({
    providedIn: 'root'
})
export class AccountService extends ApiBaseService {
    controller = 'v1/Account';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(request: ForgotPasswordRequest): Observable<any> {
        return this.post<ApiResponse<AuthToken>, ForgotPasswordRequest>(request, this.controller + `/ForgotPassword`);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(request: ResetPasswordRequest): Observable<any> {
        return this.post<ApiResponse<AuthToken>, ResetPasswordRequest>(request, this.controller + `/ResetPassword`);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }): Observable<LoginResponse> {
        return this.post<LoginResponse, LoginRequest>(credentials, this.controller + `/Login`);
    }

    confirmEmail(request: EmailConfirmationRequest): Observable<boolean> {
        return this.post<ApiResponse<any>, EmailConfirmationRequest>(request, this.controller + `/ConfirmEmail`).pipe(
            switchMap((response: ApiResponse<any>) => {
                if (response?.error) {
                    return of(false);
                }
                return of(true);
            })
        );
    }

    resendConfirmaionEmail(email: string): Observable<boolean> {
        return this.post<ApiResponse<any>, string>(email, this.controller + `/ResendEmailToken`).pipe(
            switchMap((response: ApiResponse<any>) => {
                if (response) {
                    return of(true);
                }
                if (response?.error) {
                    return of(false);
                }
            })
        );
    }

    getNewAccessToken(refreshToken: string): Observable<ApiResponse<AuthToken>> {
        return this.post<ApiResponse<AuthToken>, null>(null, this.controller + '/RefreshAccessToken?refreshToken=' + refreshToken);
    }

    /**
     * Sign up
     *
     * @param request
     */
    signUp(request: RegisterNewAccountRequest): Observable<any> {
        return this.post<ApiResponse<AuthToken>, RegisterNewAccountRequest>(request, this.controller + '/RegisterNewAccount');
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

}
